module.exports = __webpack_public_path__ + "static/media/05.e79badf8.jpeg";